import { BaSeDialogContext, BaSeTheme } from '@base/react';
import React from 'react';
import ConfirmExclusionInterview from '../dialogs/confirm-exclusion-interview';

export function useDialogConfirmExclsion() {
  const { showModal } = React.useContext(BaSeDialogContext);

  const openDialogExcluirEntrevista = React.useCallback(
    ({ moduleId, name, reloadData, cpfCandidate }) => {
      return showModal({
        actions: [],
        size: 'small',
        title: 'Confirmar exclusão',
        dismissible: true,
        dismissibleIconColor: BaSeTheme.colors.defaultColors.black,
        dismissibleIconType: 'tertiary',
        content: ({ closeModal, emitEvent }) => (
          <ConfirmExclusionInterview
            closeModal={closeModal}
            reloadData={reloadData}
            moduleId={moduleId}
            name={name}
            cpfCandidate={cpfCandidate}
          />
        ),
        onChooseAction: (action) => {
          console.log('action no visualizar: ', action);
        },
      });
    },
    [showModal],
  );

  return {
    openDialogExcluirEntrevista,
  };
}
